/* This file is autogenerated, see readme.md for instructions */
import ImageSearchSvgIcon from '@bloomreach/banana-theme/icons/image-search.svg?react';
import { forwardRef } from 'react';

import Icon from '../icon';

import type { ReactNode, Ref } from 'react';

import type { IconInstanceProps } from '../icon.types';

const ImageSearchIcon = forwardRef((props: IconInstanceProps, forwardedRef: Ref<SVGSVGElement>): ReactNode => {
  return (
    <Icon {...props} ref={forwardedRef}>
      <ImageSearchSvgIcon />
    </Icon>
  );
});

ImageSearchIcon.displayName = 'ImageSearchIcon';

export default ImageSearchIcon;
